import { useState, useRef } from "react";
import { Popper, Paper, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { formatOfficerName } from "../../utils/utils";
import { controlButton } from "./MapButtonStyling";
import { useOfficerLocation } from "./OfficerLocationContext";

const OfficerSearch = ({
  showSearch = false,
  toggleShowSearch = () => {},
  findOfficerCallback = () => {},
}) => {
  const anchorRef = useRef(null);
  const [hover, setHover] = useState(false);
  const { officerList } = useOfficerLocation();

  return (
    <div>
      <button
        ref={anchorRef}
        onMouseEnter={() => setHover("search")}
        onMouseLeave={() => setHover(false)}
        onClick={toggleShowSearch}
        style={controlButton(hover === "search")}
      >
        Find Officer
      </button>

      <Popper
        open={showSearch}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        style={{ zIndex: 2000 }}
      >
        <Paper
          elevation={3}
          style={{
            marginTop: 4,
            padding: 8,
            minWidth: 300,
            maxWidth: 400,
          }}
        >
          <Autocomplete
            id="officer-search-autocomplete"
            autoSelect
            autoHighlight
            openOnFocus
            options={officerList || []}
            getOptionLabel={option => {
              let name = formatOfficerName(option);
              if (!option?.lat || !option?.lng) {
                name = `${name} (No location data)`;
              }
              return name || "";
            }}
            style={{ width: 300 }}
            onChange={(event, officer) => {
              findOfficerCallback(officer?.id, {
                lat: officer?.lat,
                lng: officer?.lng,
              });
              toggleShowSearch(false);
            }}
            getOptionDisabled={option => !option?.lat || !option?.lng}
            renderInput={params => (
              // eslint-disable-next-line jsx-a11y/no-autofocus -- Focus search when the Find Officer panel opens.
              <TextField autoFocus
                {...params}
                label="Enter officer name or badge"
                variant="outlined"
              />
            )}
          />
        </Paper>
      </Popper>
    </div>
  );
};

export default OfficerSearch;
